// extracted by mini-css-extract-plugin
export var icon = "_40-1";
export var subtext = "_40-0";